// extracted by mini-css-extract-plugin
export default {"amountContainer":"DisplayAmount_amountContainer__MZ6M0"};